import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { Api } from '@dashboard/lib/api'

import { DiscType } from '../../../../lib/types'

export interface CreateCustomContentParams {
  section_name: string
  custom_content: {
    Dc?: DiscType
    D?: DiscType
    Di?: DiscType
    DI?: DiscType
    Id?: DiscType
    I?: DiscType
    Is?: DiscType
    IS?: DiscType
    Si?: DiscType
    S?: DiscType
    Sc?: DiscType
    SC?: DiscType
    Cs?: DiscType
    C?: DiscType
    Cd?: DiscType
    CD?: DiscType
  }
}

export const REQUEST = 'CUSTOM_CONTENT_CREATE_START'
interface RequestAction {
  type: typeof REQUEST
}
const request = (): RequestAction => ({
  type: REQUEST,
})

export const REQUEST_SUCCESS = 'CUSTOM_CONTENT_CREATE_SUCCESS'
interface RequestSuccessAction {
  type: typeof REQUEST_SUCCESS
}
const requestSuccess = (): RequestSuccessAction => ({
  type: REQUEST_SUCCESS,
})

export const REQUEST_FAILURE = 'CUSTOM_CONTENT_CREATE_FAILURE'
interface RequestFailureAction {
  type: typeof REQUEST_FAILURE
  error: unknown
}
const requestFailure = (error: unknown): RequestFailureAction => ({
  type: REQUEST_FAILURE,
  error,
})

export type Action = RequestAction | RequestSuccessAction | RequestFailureAction

export function createCustomContent(params: CreateCustomContentParams) {
  return async (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
    return new Promise<void>((resolve, reject) => {
      dispatch(request())

      Api()
        .post('/custom_contents', params)
        .then(() => {
          dispatch(requestSuccess())
          resolve()
        })
        .catch(err => {
          dispatch(requestFailure(err))
          reject(
            `Error calling createCustomContent (Status: ${err.response
              ?.status}): ${JSON.stringify(err.response?.data)}`,
          )
        })
    })
  }
}
